import * as React from 'react'

const Point = (props: any) => {
  return (
    <svg className={'icon ' + props.className} viewBox='-2 0 12 9' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M3.5 0C1.56975 0 0 1.39962 0 3.12067C0 5.06952 2.1525 7.64407 3.5 9C4.84837 7.64407 7 5.06952 7 3.12067C7 1.39962 5.43025 0 3.5 0Z'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M1.5 3C0.67275 3 0 2.32725 0 1.5C0 0.6735 0.67275 0 1.5 0C2.32725 0 3 0.6735 3 1.5C3 2.32725 2.32725 3 1.5 3Z'
        transform='translate(2 2)'
        fill='#fff'
      />
    </svg>
  )
}

export default Point



// WEBPACK FOOTER //
// ./src/components/icons/ui/Point.tsx